import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useInViewport } from 'react-in-viewport';
import cn from 'classnames';

import { getCareTeam } from '../api';
import { Button } from '../../../../components';

const CareTeamButton = ({ userId, adtId, onClick, onCareTeamLoaded }) => {
	const [isLoading, setIsLoading] = useState(true);
	const [hasCareTeam, setHasCareTeam] = useState(false);
	const spinnerRef = useRef();
	const { inViewport } = useInViewport(spinnerRef, {}, { disconnectOnLeave: true }, {});

	useEffect(() => {
		if (inViewport) {
			getCareTeam(userId, adtId)
				.then(({ data }) => {
					if (data.status && Array.isArray(data.status)) {
						if (data.status.length > 0) {
							const { records } = data.status[0];
							setHasCareTeam(Array.isArray(records) && records.length > 0);
							onCareTeamLoaded(records);
						}
					}
					setIsLoading(false);
				})
				.catch(() => {
					setIsLoading(false);
				});
		}
	}, [inViewport]);

	return (
		<React.Fragment>
			<div className={cn('mr', { hidden: !isLoading })} style={{ display: 'inline-block' }} ref={spinnerRef}>
				<span className="fa fa-spin fa-spinner" />
			</div>
			{!isLoading && hasCareTeam && (
				<Button
					success
					className="mr-xl"
					title="Care Team"
					onClick={onClick}
				/>
			)}
		</React.Fragment>
	);
};

CareTeamButton.propTypes = {
	userId: PropTypes.number.isRequired,
	adtId: PropTypes.number.isRequired,
	onClick: PropTypes.func.isRequired,
	onCareTeamLoaded: PropTypes.func.isRequired
};

export default CareTeamButton;
